import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * Labeled numeric/text field with readable label + input + optional unit tag.
 * Uses body font for labels (not monospace) so they read more naturally.
 */
export default function LabeledField({
  id,
  label,
  value,
  onChange,
  type = "number",
  step = "0.01",
  unit,
  placeholder,
  hint,
  testId,
}) {
  return (
    <div className="flex flex-col gap-1">
      <Label
        htmlFor={id}
        className="text-xs font-semibold text-[color:var(--text)] font-body"
      >
        {label}
      </Label>
      <div className="relative">
        <Input
          id={id}
          type={type}
          step={type === "number" ? step : undefined}
          value={value ?? ""}
          onChange={(e) => {
            const v = type === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value;
            onChange(v);
          }}
          placeholder={placeholder}
          data-testid={testId}
          className={`bg-[color:var(--surface)] border border-[color:var(--border)] text-[color:var(--text)] font-display font-semibold text-sm h-9 px-2.5 rounded focus-visible:ring-2 focus-visible:ring-[color:var(--brand)] focus-visible:ring-offset-1 focus-visible:ring-offset-[color:var(--bg)] focus-visible:border-[color:var(--brand)] transition-colors ${
            unit ? "pr-11" : ""
          }`}
        />
        {unit && (
          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[11px] font-semibold text-[color:var(--brand)] pointer-events-none">
            {unit}
          </span>
        )}
      </div>
      {hint && <p className="text-[10px] text-[color:var(--text-dim)] leading-tight">{hint}</p>}
    </div>
  );
}
